// Keep the marketing article route separate from product-app destinations.
export function pushLandingUrl(data, environment) {
    const production = ['prod', 'production'].includes(environment);
    const site = production ? 'https://goai.digital' : 'https://dev.goai.digital';
    const app = production ? 'https://app.goai.digital' : 'https://app.dev.goai.digital';
    if (data.type === 'POST' && data.id) return `${site}/insights/${encodeURIComponent(data.id)}`;
    if (data.type === 'INVESTMENT_IDEA' && data.id) return `${app}/investment/${encodeURIComponent(data.id)}`;
    if (data.type === 'TICKER' && data.ticker) return `${app}/ticker/${encodeURIComponent(data.ticker)}`;
    return '';
}
